module.exports = __webpack_public_path__ + "img/DSC_0082.241cfd75.jpg";